import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { startSetTicketRating, startSetTicketHelp } from '../../actions/tickets';
import Moment from 'react-moment';
import { FormattedMessage } from 'react-intl';
import { object, array, string } from 'prop-types';
import { createMarkup } from '../../utils/utils';
import ReplyRating from './ReplyRating';
import ReplyHelp from './ReplyHelp';
import Icon from '../Icon/Icon';
import { FMessage } from '../../hoc/IntlComponents';

const propTypes = {
  reply: object.isRequired,
  files: array,
  login: string,
};
const defaultProps = {
  reply: {},
  files: [],
  login: '',
};

const ReplyListItem = ({
  reply,
  files,
  login,
  avatar,
  startSetTicketRating,
  startSetTicketHelp,
  ticketId,
  getTicket,
}) => {
  const [loading, setReptyLoading] = useState(false);
  const [selectedHelp, selectHelp] = useState(null);
  const [selectedRate, selectRate] = useState(null);
  const [replyThanks, sayThanks] = useState(false);
  const setLoading = (bool) => setReptyLoading(bool);
  const handleSelectHelp = (number) => selectHelp(number);
  const handleSelectRate = (number) => selectRate(number);

  const { support_avatar, isAdmin, its, text, help, rating, id } = reply;

  const handleSetHelp = (value) => {
    setLoading(true);
    handleSelectHelp(value);
    startSetTicketHelp({ ticketId, replyId: id, value })
      .finally(() => getTicket(ticketId))
      .finally(() => setLoading(false));
  };

  const handleSetRating = (value) => {
    setLoading(true);
    handleSelectRate(value);
    startSetTicketRating({ ticketId, replyId: id, value })
      .finally(() => getTicket(ticketId))
      .finally(() => {
        setLoading(false);
        sayThanks(true);
      });
  };

  const getImageTitle = (img) => img.match(/tickets(.*)/g, '000')[0].replace('tickets/', '');

  const replaceManagerLinkTitle = (text) =>
    text.replace(
      /class="(manager__contact[^"]+)"\s+href="([^"]+)"\s+title="[^"]+"/g,
      'class="$1" href="$2"  title="$2"',
    );

  const renderTicketRatingHelpBlocks = () => {
    if (help === null) {
      return (
        <ReplyHelp
          onSubmit={handleSetHelp}
          loading={loading}
          selected={selectedHelp}
          replyId={id}
        />
      );
    } else {
      if (rating === null) {
        return (
          <ReplyRating
            onSubmit={handleSetRating}
            loading={loading}
            selected={selectedRate}
            replyId={id}
          />
        );
      } else {
        if (replyThanks) {
          return (
            <div className="ticket-reply-thanks">
              <FMessage id="tickets.reply-rate.thanks" />
            </div>
          );
        }
      }
    }
    return null;
  };
  return (
    <div className={cn('replies-list-item', { isAdmin })}>
      <div className="ticket-icon">
        <div className="user-avatar">
          {isAdmin ? (
            <img className="rounded-circle img-fluid" src={support_avatar} alt="" />
          ) : (
            <>{avatar && <img className="rounded-circle img-fluid" src={avatar} alt="" />}</>
          )}
        </div>
      </div>
      <div className="ticket-content">
        <div className="ticket-info">
          <div className="ticket-info-author">
            <b>
              {isAdmin ? (
                <>
                  <FormattedMessage id="tickets.support_service" defaultMessage="Support service" />
                </>
              ) : (
                login
              )}
            </b>
          </div>
          <div className="ticket-info-time">
            <Moment format="LT" unix>
              {its}
            </Moment>
          </div>
        </div>
        <div
          className={cn({ 'user-ticket': !isAdmin }, 'ticket-message')}
          dangerouslySetInnerHTML={createMarkup(replaceManagerLinkTitle(text))}
        />
        {files && (
          <div className="ticket-images">
            {files.map(({ preview, img }, index) => (
              <a href={img} target="_blank" key={index}>
                <img src={preview} />
              </a>
            ))}
          </div>
        )}
        {isAdmin && renderTicketRatingHelpBlocks()}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  startSetTicketRating: (params) => dispatch(startSetTicketRating(params)),
  startSetTicketHelp: (params) => dispatch(startSetTicketHelp(params)),
});

ReplyListItem.propTypes = propTypes;
ReplyListItem.defaultProps = defaultProps;

export default connect(null, mapDispatchToProps)(ReplyListItem);
